export const STATUS = {
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  ON: 'on',
  OFF: 'off',
  DEFAULT: 'Default',
  CUSTOM: 'Custom',
  SUCCESS: 'success',
};
